import { BrowserModule } from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { GlobalServiceService } from './global-service.service';
import { HttpService} from './http.service'


import { AppComponent } from './app.component';
import { MainHeaderComponent } from './main-header.component';
import { FooterComponent } from './footer.component';
import { ProsComponent } from './homepage/pros.component';
import { SkillsComponent } from './homepage/skills.component';
import { DevelopmentProcessComponent } from './homepage/development-process.component';
import { ProsFullComponent } from './homepage/pros-full.component';
import { ContactFormSmallComponent } from './homepage/contact-form-small.component';
import { OurServicesComponent } from './about us/our-services.component';
import { StatisticsComponent } from './about us/statistics.component';
import { TeamComponent } from './about us/team.component';
import { QuotesComponent } from './about us/quotes.component';
import { ContactFormBigComponent } from './contactForm/contact-form-big.component';
import { FaqComponent } from './faq/faq.component';
import { PartfolioGalleryComponent } from './portfolio/portfolio-gallery.component';
import { PartfolioItemComponent } from './portfolio/portfolio-item.component';
import { ServicesComponent } from './services/services.component';
import { ServicesDescriptionComponent } from './services/services-description.component';
import { PortfolioComponent } from './portfolio/portfolio.component';
import { HomePageComponent } from './homepage/home-page.component';
import { FaqContentComponent } from './faq/faq-content.component';
import { ContactFormComponent } from './contactForm/contact-form.component';
import { AboutUsComponent } from './about us/about-us.component';
import { SubheaderComponent } from './subheader.component';
import {routing} from "./app.routes";
import { WebDesignComponent } from './services/descriptionComponents/web-design.component';
import { SeoComponent } from './services/descriptionComponents/seo.component';
import { LogoComponent } from './services/descriptionComponents/logo.component';
import { MobileComponent } from './services/descriptionComponents/mobile.component';
import { BrandingComponent } from './services/descriptionComponents/branding.component';
import { MarketingComponent } from './services/descriptionComponents/marketing.component';

@NgModule({
  declarations: [
    AppComponent,
    MainHeaderComponent,
    FooterComponent,
    ProsComponent,
    SkillsComponent,
    DevelopmentProcessComponent,
    ProsFullComponent,
    ContactFormSmallComponent,
    OurServicesComponent,
    StatisticsComponent,
    TeamComponent,
    QuotesComponent,
    ContactFormBigComponent,
    FaqComponent,
    PartfolioGalleryComponent,
    PartfolioItemComponent,
    ServicesComponent,
    ServicesDescriptionComponent,
    PortfolioComponent,
    HomePageComponent,
    FaqContentComponent,
    ContactFormComponent,
    AboutUsComponent,
    SubheaderComponent,
    WebDesignComponent,
    SeoComponent,
    LogoComponent,
    MobileComponent,
    BrandingComponent,
    MarketingComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    routing,
  ],
  providers: [ GlobalServiceService, HttpService ],
  bootstrap: [AppComponent],
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/app.module.ts